import { EtatTacheService } from './../../../tache/shared/services/etatTache.service';
import { Component, OnInit, Input } from '@angular/core';
import { imgCardDrop } from '../../classes/animations';
import { EtatTache } from '../../../tache/shared/classes/etatTache';
import { FormControl } from '@angular/forms';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { AlertService } from '../../services/alert.service';
import { StorageService } from '../../services/storage.service';
import { TypeConvention } from '../../../infrastructure/shared/classes/type_convention';
import { TRANSLATE } from '../../classes/translatable';

@Component({
  selector: 'app-admin-list-type-etat-tache',
  templateUrl: './admin-list-type-etat-tache.component.html',
  styleUrls: ['./admin-list-type-etat-tache.component.css'],
  animations: [imgCardDrop]
})
export class AdminListTypeEtatTacheComponent implements OnInit {

    etats: EtatTache[];
    newEtat = new EtatTache();
    selected = new FormControl(0);

    @Input()
    triggerReload: () => void;

    aclConfig: AclAccess;

    constructor(
        private etatTacheService: EtatTacheService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.etats = [];
    }


    getEtats() {
        this.etats = [];
        this.etatTacheService.getEtatTache()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.etats.push(new EtatTache(element));
                });
            }
        });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getEtats();
        }
    }

    insertEtat(etat: EtatTache) {
        this.etatTacheService.insertEtatTache(etat)
        .subscribe(retour => {
            if (retour.status === 201) {
                this.newEtat = new EtatTache();
                this.alertService.success(TRANSLATE('État de tache ajouté avec succès'));
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateEtat(etat: EtatTache) {
        this.etatTacheService.updateEtatTache(etat.aee_id, etat)
        .subscribe(retour => {
            if (retour.status === 201) {
                this.alertService.success(TRANSLATE('État de tache modifié avec succès'));
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteEtat(etat: EtatTache) {
        this.etatTacheService.deleteEtatTache(etat.aee_id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('État de tache supprimé avec succès'));
                this.getEtats();
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

}
